export default "__VITE_ASSET__BbBToCzw__"